export default "__VITE_ASSET__uwg$y6vf__"